export function parseProductInfo(rawText) {
    const lines = rawText
      .split('\n')
      .map(line => line.trim())
      .filter(Boolean);
  
    return [
      lines.slice(0, 2).join('\n'),
      lines.slice(2, 5).join('\n'),
      lines[6] || "",
      lines[5] || ""
    ];
  }